import React from "react";
import {CButton} from "@coreui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import {colors} from "../../../utils/theme";

const NewButton = ({value , onClick, icon, color = "#FFFFF", className="btn btn-dark btn-sm"}) => {

  return(
    <>
      <CButton className={className} onClick={onClick} style={{marginRight:5}}>
        <span> <FontAwesomeIcon icon={icon ? icon : faPlus} />{value ? ' ' + value : ''}</span>
      </CButton>
    </>
  )
}
export default NewButton
